/**
 * Floating access point for the Voice Diagnostics modal when
 * Developer Mode is on. Top-right corner, subtle enough to ignore
 * but unmistakably "this is debug territory" so it never gets
 * confused for a user-facing control.
 */
import { Terminal } from "lucide-react";

interface DevPillProps {
  onOpen: () => void;
}

export function DevPill({ onOpen }: DevPillProps) {
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="Open voice diagnostics"
      className="fixed z-[9998] flex items-center gap-1.5 rounded-full border border-yellow-400/50 bg-black/60 px-2.5 py-1 text-[11px] font-mono font-bold uppercase tracking-widest text-yellow-300 shadow-lg backdrop-blur active:scale-95"
      style={{
        top: "calc(env(safe-area-inset-top, 0px) + 12px)",
        left: "12px",
      }}
    >
      <Terminal className="h-3 w-3" />
      dev
    </button>
  );
}
